import { TextureAreaVO } from '../vo/meta-element.vo';
import { MetaElementUtils } from '@article/components/connections/connection-creation/meta-element.utils';

export class TextureAreaUtils {
  public static isEditable(textureArea: TextureAreaVO): boolean {
    return TextureAreaVO.TEXT_TYPES.includes(textureArea.textureType)
      || MetaElementUtils.isDyeable(textureArea);
  }
}
